import { fleetManagementApi } from "../api";

export const getUsers = async () => {
  const response = await fleetManagementApi.get("/users");
  return response;
}

export const getUserById = async (userId) => {
  const response = await fleetManagementApi.get(`/users/${userId}`);
  return response.data;
}

export const createUser = async (userData) => {
  const response = await fleetManagementApi.post("/users", userData);
  return response.data;
}

export const updateUser = async (userId, userData) => {
  const response = await fleetManagementApi.put(`/users/${userId}`, userData);
  return response.data;
}

export const deleteUser = async (userId) => {
  const response = await fleetManagementApi.delete(`/users/${userId}`);
  return response.data;
}